import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import FilterGroup from './filter_group.jsx'
import { Checkbox } from 'lensrentals-components'

const CheckFilter = props => {
  const {
    name,
    values,
    filterType,
    selectedFilters,
    handleFilterSelection,
    selectFilter,
    deselectFilter,
    isOpen,
    toggleOpenFilters,
    isExpanded,
    toggleExpandedFilters
  } = props

  const onChangeCheckFilter = useCallback((event) => {
    let newSelectedFilters
    let convertedName = name
    let convertedValue = event.target.name
    if (name === 'Rent or Buy') {
      if (convertedValue === 'Rent') {
        convertedName = 'For Rent'
        convertedValue = 'Yes'
      } else {
        convertedName = 'For Sale'
        convertedValue = 'Yes'
      }
    }
    if (event.target.checked) {
      newSelectedFilters = selectFilter(selectedFilters, filterType, convertedName, convertedValue)
    } else {
      newSelectedFilters = deselectFilter(selectedFilters, filterType, convertedName, convertedValue)
    }
    handleFilterSelection(newSelectedFilters, event)
  }, [selectFilter, deselectFilter, handleFilterSelection, filterType, name, selectedFilters])

  const isSelected = useCallback((filterType, filterName, name) => {
    // {"string_filters":[{"name":"Lens Type","values":["Normal Range"]}],"number_filters":[],"number_range_filters":[]}
    const currentSelectedFilters = selectedFilters ? JSON.parse(selectedFilters) : {}

    if (currentSelectedFilters[filterType]) {
      let existingFilter
      if (filterName === 'Rent or Buy') {
        const convertedName = name === 'Rent' ? 'For Rent' : 'For Sale'
        existingFilter = currentSelectedFilters[filterType].find(filter => filter.name === convertedName && filter.values.includes('Yes'))
      } else {
        existingFilter = currentSelectedFilters[filterType].find(filter => filter.name === filterName && filter.values.includes(name))
      }
      return !!existingFilter
    }
    return false
  }, [selectedFilters])

  const filterName = name
  return (
    <FilterGroup
      name={name}
      isOpen={isOpen}
      toggleOpenFilters={toggleOpenFilters}
      isExpanded={isExpanded}
      toggleExpandedFilters={toggleExpandedFilters}
    >

      {values.map((value, index) => {
        const { name, count } = value
        return (
          <Checkbox
            key={`${filterName}-${index}-${name}`}
            label={count || Number.isInteger(count) ? `${name} (${count})` : `${name}`}
            name={name}
            id={`${filterName}-${name}`.replace(/\s+/g, '-')}
            value={`${name} (${count})`}
            checked={isSelected(filterType, filterName, name)}
            onChange={onChangeCheckFilter}
          />
        )
      })}
    </FilterGroup>
  )
}
CheckFilter.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  filterType: PropTypes.string,
  selectedFilters: PropTypes.string.isRequired,
  handleFilterSelection: PropTypes.func.isRequired,
  selectFilter: PropTypes.func.isRequired,
  deselectFilter: PropTypes.func.isRequired
}
export default CheckFilter
